import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface Notification {
  id: string;
  productId: string;
  productName: string;
  message: string;
  isRead: boolean;
  createdAt: string;
  type?: string;
}

export interface NotificationState {
  items: Notification[];
  unreadCount: number;
}

const initialState: NotificationState = {
  items: [],
  unreadCount: 0,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    markAsRead: (state, action: PayloadAction<string>) => {
      const notification = state.items.find(
        (item) => item.id === action.payload
      );
      if (notification && !notification.isRead) {
        notification.isRead = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },

    removeNotification: (state, action: PayloadAction<string>) => {
      const index = state.items.findIndex((item) => item.id === action.payload);
      if (index !== -1) {
        const notification = state.items[index];
        if (!notification.isRead) {
          state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
        state.items.splice(index, 1);
      }
    },
    setNotifications: (
      state,
      action: PayloadAction<{ notifications: Notification[]; count: number }>
    ) => {
      state.items = action.payload.notifications;
      state.unreadCount = action.payload.count;
    },
  },
});

export const { markAsRead, removeNotification, setNotifications } =
  notificationSlice.actions;

export default notificationSlice.reducer;
